import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2E90FA',
      dark: '#1565c0',
      light: '#76b6ff',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#1976d2',
      dark: '#1565c0',
      light: '#4287f5',
    },
    error: {
      main: '#F44336',
      light: '#FFE6E6',
    },
    warning: {
      main: '#FFA500',
      light: '#FFF9E6',
    },
    success: {
      main: '#4CAF50',
      light: '#E6F7EE',
    },
    info: {
      main: '#2196F3',
      light: '#E6F2FF',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
    divider: '#e0e0e0',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      '"Fira Sans"',
      '"Droid Sans"',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
  },
});

// Custom tokens for the dark map/explore UI
export const mapColors = {
  background: '#1E2126',
  surface: '#2A2E35',
  text: '#B9CEF0',
  textSecondary: '#A6B6CE',
  overlay: 'rgba(22, 22, 22, 0.95)',
  primaryBlue: '#2E90FA',
  accentBlue: 'rgba(46, 144, 250, 0.3)',
  accentBlueFaint: 'rgba(46, 144, 250, 0.2)',
};

// Order status color mapping
export const statusColors = {
  requested: { bg: '#F0F0F0', text: '#666666' },
  accepted: { bg: '#E6F2FF', text: '#2196F3' },
  delayed: { bg: '#FFF9E6', text: '#FFA500' },
  delivered: { bg: '#E6F7EE', text: '#4CAF50' },
  rejected: { bg: '#FFE6E6', text: '#F44336' },
  default: { bg: '#f5f5f5', text: '#666666' },
};

export default theme;
